const termsContentES = {
  title: 'Términos y Condiciones de Uso',
  lastUpdated: '8 de septiembre de 2026',
  sections: [
    {
      id: 'introduction',
      title: '1. Objeto y aceptación',
      content: [
        'Bienvenido a Coolliving (coolliving.io), una plataforma de búsqueda y conexión de espacios coliving en España. Al acceder y utilizar la plataforma, usted acepta quedar vinculado por los presentes Términos y Condiciones. Si no está de acuerdo con alguno de ellos, le rogamos que no utilice el servicio.',
        'Coolliving es un servicio de intermediación que ayuda a personas que buscan coliving a conectar con operadores del sector. No somos propietarios, gestores ni representantes de ninguno de los espacios listados en la plataforma.',
      ]
    },
    {
      id: 'cookies',
      title: '2. Cookies',
      content: [
        'Coolliving utiliza cookies conforme a nuestra Política de Cookies (coolliving.io/cookies). Al navegar por el sitio, acepta el uso de cookies técnicas necesarias para el funcionamiento de la plataforma.',
        'Las cookies analíticas y publicitarias (incluidas las de Google AdSense) solo se activan si usted las acepta expresamente en el banner de cookies. Puede revocar su consentimiento en cualquier momento.',
      ]
    },
    {
      id: 'services',
      title: '3. Descripción de los servicios',
      content: [
        'Coolliving ofrece dos tipos de funcionalidades principales:',
        '· Buscador de colivings: agregamos y mostramos listados de espacios coliving disponibles en España, obtenidos de fuentes públicas o directamente de los operadores. La información de precios, disponibilidad y condiciones es orientativa y puede no estar actualizada.',
        '· Servicio de conexión con operadores — Modelo 1 (cobro por lead): cuando usted envía una solicitud de coliving a través de nuestro formulario, el equipo de Coolliving selecciona manualmente hasta 5 operadores relevantes para su búsqueda y les comunica sus datos de contacto e información de búsqueda. Este servicio es gratuito para el usuario solicitante.',
        '· Gestión de contratos de alquiler: herramientas para que propietarios e inquilinos gestionen contratos de arrendamiento de forma digitalizada.',
      ]
    },
    {
      id: 'leads-service',
      title: '4. Servicio de solicitud de coliving (leads)',
      content: [
        'Al enviar una solicitud de coliving a través del formulario habilitado para ello, usted:',
        '(a) Confirma que la información proporcionada (nombre, email, teléfono, preferencias de búsqueda) es veraz y actualizada.',
        '(b) Consiente expresamente que sus datos sean comunicados a operadores de coliving seleccionados por el equipo de Coolliving, con el fin de recibir propuestas personalizadas.',
        '(c) Entiende que Coolliving actúa como intermediario: no garantizamos que los operadores contactados respondan, ni que dispongan de plazas en las condiciones solicitadas.',
        '(d) Acepta poder recibir comunicaciones directamente de los operadores a los que se hayan remitido sus datos, quienes son responsables autónomos del tratamiento de sus datos a partir de ese momento.',
        'Coolliving se reserva el derecho de rechazar solicitudes que contengan información falsa, incompleta o que puedan constituir un uso abusivo del servicio.',
      ]
    },
    {
      id: 'user-obligations',
      title: '5. Obligaciones del usuario',
      content: [
        'Para utilizar la plataforma, el usuario debe ser mayor de 18 años y proporcionar información veraz en el registro y en los formularios.',
        'Está prohibido: utilizar la plataforma con fines fraudulentos o ilegales, enviar solicitudes masivas o automatizadas, suplantar la identidad de terceros, publicar contenido falso o engañoso, e intentar acceder a áreas restringidas de la plataforma.',
        'El incumplimiento de estas obligaciones podrá dar lugar a la suspensión o cancelación de la cuenta sin previo aviso.',
      ]
    },
    {
      id: 'intellectual-property',
      title: '6. Propiedad intelectual',
      content: [
        'El diseño, código, marcas y contenidos propios de Coolliving son propiedad de sus titulares y están protegidos por la legislación de propiedad intelectual e industrial.',
        'Los listados de colivings de terceros son propiedad de sus respectivos operadores. Coolliving los muestra con fines informativos y no reclama derechos sobre ellos.',
        'Queda prohibida la reproducción, distribución o uso comercial de los contenidos de la plataforma sin autorización expresa de Coolliving.',
      ]
    },
    {
      id: 'liability',
      title: '7. Limitación de responsabilidad',
      content: [
        'Coolliving no es parte en los contratos de arrendamiento ni en los acuerdos que puedan surgir entre usuarios y operadores de coliving. Nuestra responsabilidad se limita a la prestación del servicio de intermediación y búsqueda.',
        'No garantizamos la exactitud, integridad o actualidad de los listados mostrados en la plataforma, que provienen en su mayoría de fuentes externas mediante indexación automatizada de información pública.',
        'Coolliving no será responsable de: (a) la calidad o condiciones reales de los espacios coliving; (b) el incumplimiento por parte de operadores de los compromisos adquiridos con los usuarios; (c) pérdidas económicas derivadas de transacciones entre usuarios y operadores; (d) interrupciones del servicio debidas a causas de fuerza mayor o mantenimiento.',
      ]
    },
    {
      id: 'transactions',
      title: '8. Pagos',
      content: [
        'El uso del buscador y el servicio de solicitud de coliving es gratuito para los usuarios solicitantes.',
        'Los contratos de arrendamiento gestionados a través de la plataforma pueden implicar una tarifa de compromiso procesada mediante Stripe, procesador de pagos externo que cumple con el estándar PCI DSS.',
        'Los operadores de coliving que participan en el Modelo 1 de cobro por lead acuerdan con Coolliving las condiciones económicas en contratos separados.',
      ]
    },
    {
      id: 'advertising',
      title: '9. Publicidad en la plataforma',
      content: [
        'Coolliving puede mostrar anuncios de terceros en determinadas páginas del sitio web (por ejemplo, el buscador de colivings y el blog) a través de Google AdSense u otros proveedores publicitarios.',
        'Estos anuncios son claramente identificables como contenido publicitario y son independientes de los listados de colivings indexados en la plataforma. La presencia de un anuncio no implica recomendación, patrocinio ni vinculación comercial de Coolliving con el anunciante, salvo indicación expresa.',
        'Los anuncios solo se muestran a usuarios que hayan aceptado las cookies publicitarias conforme a nuestra Política de Cookies. Coolliving no controla el contenido específico de cada anuncio, aunque puede bloquear categorías publicitarias inadecuadas desde el panel de AdSense.',
        'Los ingresos publicitarios ayudan a mantener el buscador de colivings gratuito para los residentes. Esto no afecta al servicio de solicitud de coliving ni supone comisiones para el usuario.',
      ]
    },
    {
      id: 'hyperlinks',
      title: '10. Enlaces e iFrames',
      content: [
        'Organizaciones como agencias públicas, motores de búsqueda u organizaciones de noticias pueden enlazar a coolliving.io sin autorización previa por escrito, siempre que el enlace no sea engañoso, no implique falsamente patrocinio y encaje en el contexto del sitio que enlaza.',
        'Otras organizaciones pueden solicitar autorización de enlace escribiendo a hola@coolliving.io indicando su nombre, organización, URL y las páginas a las que desea enlazar.',
        'No está permitido crear marcos (iFrames) alrededor de nuestras páginas que alteren su presentación visual sin permiso expreso por escrito de Coolliving.',
      ]
    },
    {
      id: 'legal-framework',
      title: '11. Legislación aplicable y resolución de disputas',
      content: [
        'Estos términos se rigen por la legislación española. En caso de litigio, ambas partes se someten a los tribunales competentes del domicilio del usuario, o a los de Madrid si el usuario es una empresa.',
        'Coolliving cumple con el Reglamento (UE) 2016/679 (RGPD), la Ley Orgánica 3/2018 (LOPDGDD) y la Ley 34/2002 de Servicios de la Sociedad de la Información (LSSI-CE).',
      ]
    },
    {
      id: 'modifications',
      title: '12. Modificaciones de los términos',
      content: [
        'Coolliving se reserva el derecho de modificar estos términos en cualquier momento. Los cambios sustanciales serán notificados a los usuarios registrados por correo electrónico con al menos 15 días de antelación.',
        'El uso continuado de la plataforma tras la entrada en vigor de los nuevos términos implica su aceptación.',
      ]
    },
    {
      id: 'operators',
      title: '13. Información para operadores de coliving',
      content: [
        'Coolliving indexa y muestra información pública de espacios coliving con el objetivo de facilitar a los usuarios la búsqueda y comparación de opciones disponibles. Actuamos como un buscador sectorial que agrega información de acceso público, de manera análoga a como los buscadores generalistas indexan contenido web.',
        'Los operadores de coliving cuyos listados aparecen en la plataforma no tienen obligación de mantener una relación comercial con Coolliving. Si desea que su espacio no aparezca en nuestro buscador, puede solicitar su exclusión enviando un correo a hola@coolliving.io indicando el nombre del espacio y la URL de su web. Más información en coolliving.io/para-operadores.',
        'Las solicitudes de exclusión se tramitan en un plazo máximo de 5 días laborables. La exclusión implica la desactivación de todos los listados vinculados a ese operador.',
        'Coolliving no almacena copias locales de imágenes de operadores. Las imágenes mostradas se cargan directamente desde las URLs originales publicadas por cada operador. Si detecta un uso indebido de sus contenidos, contacte con hola@coolliving.io.',
        'Los operadores que deseen publicar sus espacios directamente en la plataforma, con gestión de disponibilidad en tiempo real y acceso a leads cualificados, pueden registrarse como agentes en coolliving.io/registro-agente.',
      ]
    },
    {
      id: 'contact',
      title: '14. Contacto',
      content: [
        'Para cualquier consulta sobre estos términos y condiciones:',
        'Email: hola@coolliving.io',
        'Coolliving · coolliving.io',
      ]
    }
  ]
}

const termsContentEN = {
  title: 'Terms and Conditions of Use',
  lastUpdated: 'September 8, 2026',
  sections: [
    {
      id: 'introduction',
      title: '1. Purpose and acceptance',
      content: [
        'Welcome to Coolliving (coolliving.io), a platform for searching and connecting with coliving spaces. By accessing and using the platform, you agree to be bound by these Terms and Conditions. If you disagree with any of them, please do not use the service.',
        'Coolliving is an intermediary service that helps people looking for coliving spaces connect with operators in the sector. We are not owners, managers, or representatives of any of the spaces listed on the platform.',
      ]
    },
    {
      id: 'cookies',
      title: '2. Cookies',
      content: [
        'Coolliving uses cookies in accordance with our Cookie Policy (coolliving.io/cookies). By browsing the site, you accept the use of technical cookies necessary for the platform to function.',
        'Analytical and advertising cookies (including Google AdSense) are only activated if you expressly accept them in the cookie banner. You may revoke your consent at any time.',
      ]
    },
    {
      id: 'services',
      title: '3. Description of services',
      content: [
        'Coolliving offers two main types of functionality:',
        '· Coliving search engine: we aggregate and display listings of available coliving spaces, sourced from public information or directly from operators. Pricing, availability, and conditions are indicative and may not be up to date.',
        '· Operator connection service — Model 1 (pay-per-lead): when you submit a coliving request through our form, the Coolliving team manually selects up to 5 relevant operators for your search and communicates your contact details and search preferences to them. This service is free for the requesting user.',
        '· Rental contract management: tools for landlords and tenants to manage lease agreements digitally.',
      ]
    },
    {
      id: 'leads-service',
      title: '4. Coliving request service (leads)',
      content: [
        'By submitting a coliving request through the designated form, you:',
        '(a) Confirm that the information provided (name, email, phone, search preferences) is truthful and up to date.',
        '(b) Expressly consent to your data being communicated to coliving operators selected by the Coolliving team, in order to receive personalized proposals.',
        '(c) Understand that Coolliving acts as an intermediary: we do not guarantee that contacted operators will respond, nor that they have availability under the requested conditions.',
        '(d) Accept that you may receive communications directly from the operators to whom your data has been sent, who become independent data controllers from that point onwards.',
        'Coolliving reserves the right to reject requests that contain false or incomplete information or that may constitute misuse of the service.',
      ]
    },
    {
      id: 'user-obligations',
      title: '5. User obligations',
      content: [
        'To use the platform, users must be at least 18 years old and provide truthful information in registration and forms.',
        'The following is prohibited: using the platform for fraudulent or illegal purposes, sending mass or automated requests, impersonating third parties, publishing false or misleading content, and attempting to access restricted areas of the platform.',
        'Breach of these obligations may result in suspension or cancellation of the account without prior notice.',
      ]
    },
    {
      id: 'intellectual-property',
      title: '6. Intellectual property',
      content: [
        'The design, code, trademarks, and proprietary content of Coolliving are owned by their respective holders and are protected by intellectual and industrial property legislation.',
        'Third-party coliving listings are the property of their respective operators. Coolliving displays them for informational purposes and claims no rights over them.',
        'Reproduction, distribution, or commercial use of platform content without express authorization from Coolliving is prohibited.',
      ]
    },
    {
      id: 'liability',
      title: '7. Limitation of liability',
      content: [
        'Coolliving is not a party to lease agreements or any arrangements that may arise between users and coliving operators. Our liability is limited to providing the intermediation and search service.',
        'We do not guarantee the accuracy, completeness, or timeliness of the listings displayed on the platform, which are mostly sourced from external public information through automated indexing.',
        'Coolliving shall not be liable for: (a) the actual quality or conditions of coliving spaces; (b) breach by operators of commitments made to users; (c) financial losses arising from transactions between users and operators; (d) service interruptions due to force majeure or maintenance.',
      ]
    },
    {
      id: 'transactions',
      title: '8. Payments',
      content: [
        'Use of the search engine and coliving request service is free for requesting users.',
        'Lease agreements managed through the platform may involve a commitment fee processed via Stripe, an external payment processor compliant with PCI DSS standards.',
        'Coliving operators participating in the pay-per-lead Model 1 agree economic terms with Coolliving in separate contracts.',
      ]
    },
    {
      id: 'advertising',
      title: '9. Advertising on the platform',
      content: [
        'Coolliving may display third-party ads on certain pages of the website (for example, the coliving search engine and blog) through Google AdSense or other advertising providers.',
        'These ads are clearly identifiable as advertising content and are independent of coliving listings indexed on the platform. The presence of an ad does not imply recommendation, sponsorship, or commercial affiliation of Coolliving with the advertiser, unless expressly stated.',
        'Ads are only shown to users who have accepted advertising cookies in accordance with our Cookie Policy. Coolliving does not control the specific content of each ad, although it may block inappropriate ad categories from the AdSense panel.',
        'Advertising revenue helps keep the coliving search engine free for residents. This does not affect the coliving request service nor does it involve commissions for the user.',
      ]
    },
    {
      id: 'hyperlinks',
      title: '10. Links and iFrames',
      content: [
        'Organizations such as government agencies, search engines, or news organizations may link to coolliving.io without prior written authorization, provided the link is not misleading, does not falsely imply sponsorship, and fits the context of the linking site.',
        'Other organizations may request link authorization by emailing hola@coolliving.io with their name, organization, URL, and the pages they wish to link to.',
        'Creating frames (iFrames) around our pages that alter their visual presentation is not permitted without express written permission from Coolliving.',
      ]
    },
    {
      id: 'legal-framework',
      title: '11. Applicable law and dispute resolution',
      content: [
        'These terms are governed by Spanish law. In case of litigation, both parties submit to the competent courts of the user\'s domicile, or to those of Madrid if the user is a company.',
        'Coolliving complies with Regulation (EU) 2016/679 (GDPR), Spanish Organic Law 3/2018 (LOPDGDD), and Law 34/2002 on Information Society Services (LSSI-CE).',
      ]
    },
    {
      id: 'modifications',
      title: '12. Modifications to the terms',
      content: [
        'Coolliving reserves the right to modify these terms at any time. Substantial changes will be notified to registered users by email at least 15 days in advance.',
        'Continued use of the platform after the new terms take effect implies acceptance.',
      ]
    },
    {
      id: 'operators',
      title: '13. Information for coliving operators',
      content: [
        'Coolliving indexes and displays public information about coliving spaces to help users search and compare available options. We act as a sector-specific search engine that aggregates publicly accessible information, similarly to how general search engines index web content.',
        'Coliving operators whose listings appear on the platform are not required to maintain a commercial relationship with Coolliving. If you wish your space to be removed from our search engine, you may request exclusion by emailing hola@coolliving.io with the name of the space and your website URL. More information at coolliving.io/para-operadores.',
        'Exclusion requests are processed within a maximum of 5 business days. Exclusion results in the deactivation of all listings linked to that operator.',
        'Coolliving does not store local copies of operator images. Displayed images are loaded directly from the original URLs published by each operator. If you detect improper use of your content, contact hola@coolliving.io.',
        'Operators who wish to publish their spaces directly on the platform, with real-time availability management and access to qualified leads, can register as agents at coolliving.io/registro-agente.',
      ]
    },
    {
      id: 'contact',
      title: '14. Contact',
      content: [
        'For any questions about these terms and conditions:',
        'Email: hola@coolliving.io',
        'Coolliving · coolliving.io',
      ]
    }
  ]
}

export const termsContent = termsContentES

export const termsContentByLocale = {
  es: termsContentES,
  en: termsContentEN,
}

export function getTermsContent(locale = 'es') {
  return termsContentByLocale[locale] || termsContentES
}
